import React, { useMemo } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { useAppTheme } from '../../utils/useAppTheme';

// Hebrew keyboard layout (standard Israeli keyboard)
const hebrewLayout = [
  ['ק', 'ר', 'א', 'ט', 'ו', 'ן', 'ם', 'פ'],
  ['ש', 'ד', 'ג', 'כ', 'ע', 'י', 'ח', 'ל', 'ך', 'ף'],
  ['ז', 'ס', 'ב', 'ה', 'נ', 'מ', 'צ', 'ת', 'ץ'],
  ['Space', 'Backspace']
];

export default function HebrewKeyboard({ onKeyPress, visible = true }) {
  const { colors } = useAppTheme();
  const styles = useMemo(() => createStyles(colors), [colors]);

  if (!visible) return null;

  const handleKeyPress = (key) => {
    if (key === 'Space') {
      onKeyPress(' ');
    } else if (key === 'Backspace') {
      onKeyPress('backspace');
    } else {
      onKeyPress(key);
    }
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Hebrew Keyboard</Text>
      {hebrewLayout.map((row, rowIndex) => (
        <View key={rowIndex} style={styles.row}>
          {row.map((key, keyIndex) => (
            <TouchableOpacity
              key={keyIndex}
              style={[
                styles.key,
                (key === 'Space' || key === 'Backspace') && styles.specialKey
              ]}
              onPress={() => handleKeyPress(key)}
            >
              <Text style={[
                styles.keyText,
                (key === 'Space' || key === 'Backspace') && styles.specialKeyText
              ]}>
                {key === 'Space' ? 'רווח' : key === 'Backspace' ? '←' : key}
              </Text>
            </TouchableOpacity>
          ))}
        </View>
      ))}
    </View>
  );
}

const createStyles = (colors) => StyleSheet.create({
  container: {
    backgroundColor: colors.mutedSurface,
    padding: 10,
    borderRadius: 8,
    marginTop: 10,
    marginBottom: 10,
    borderWidth: 1,
    borderColor: colors.border,
  },
  title: {
    fontSize: 14,
    fontWeight: 'bold',
    color: colors.text,
    marginBottom: 10,
    textAlign: 'center',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 6,
    flexWrap: 'wrap',
    gap: 4,
  },
  key: {
    backgroundColor: colors.surfaceElevated,
    paddingVertical: 10,
    paddingHorizontal: 12,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: colors.border,
    minWidth: 40,
    height: 44,
    alignItems: 'center',
    justifyContent: 'center',
    shadowColor: colors.shadow,
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
    elevation: 2,
  },
  specialKey: {
    backgroundColor: colors.primary,
    minWidth: 140,
    flex: 1,
  },
  keyText: {
    fontSize: 16,
    fontWeight: '600',
    color: colors.text,
  },
  specialKeyText: {
    color: colors.onPrimary,
    fontSize: 14,
  },
});
